import { PagerService } from './../../_services/pager.service';
import { BeatblipUtils } from './../../consts/beatblip-utils';
import { map } from 'rxjs/operators';
import { Chart } from './chart';
import { DatePipe, DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ProjectService } from 'src/app/_services/project.service';
import { ReportService } from 'src/app/_services/report.service';
import { TestService } from 'src/app/_services/test.service';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ExcelService } from 'src/app/_services/excel.service';
import { ChartColor, ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label, SingleDataSet } from 'ng2-charts';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
// import * as moment from 'moment/moment';
import moment from 'moment-timezone';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';
// import * as pluginLabels from 'chartjs-plugin-labels';
@Component({
  selector: 'app-latest-report',
  templateUrl: './latest-report.component.html',
  styleUrls: ['./latest-report.component.scss']
})
export class LatestReportComponent implements OnInit, AfterViewInit {
  projectId: any;
  projectReportData: any;
  projectData: any;
  projectName: any;
  toDate :any;
  fromDate :any;
  
  testStatus = ['ALL','PASS','FAIL','INCONCLUSIVE','SKIPPED','BLOCKED','NOT RUN'];
  suitFileData: any;
  suit = [{ title : 'ALL', id : '' }];
  keyPairSuite = [];
  suiteValue = 'ALL';
  statusV = 'ALL';
  suiteId: any;
  enableSuite: boolean;
  indexFormArray: UntypedFormArray;
  form:UntypedFormGroup;
  getSuitReportData: any;
  getSuitTableReportData: any;
  url: string;
  tz: any = 'ALL';
  enableMergereport: boolean = false;
  item: {};
  jsonToBeUsedForList: any;
  exportPdf: boolean;
  charData: any=[];
  public chartOptionSelect = ['pie','bar'];
  public barChartLabels: Label[];
  public barChartType: ChartType = 'pie';
  public barChartType2: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[]=[];
  public pieColor: ChartColor[]=[];
  chartList: Array<Chart> = [];
  blinkArry: any[]=[];
  numarray: Array<Number>=[];
  testLabels: any[] = [];
  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
    }
  };
  public barChartColors: ChartColor[] = [
    'rgb(92, 184, 92)',
    'rgb(217, 83, 79)',
    'rgb(236, 59, 15)',
    'rgb(240, 173, 78)',
     'rgb(91, 192, 222)', 
     'rgb(102, 205, 170)'
  ];
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : '',
    data: undefined,
  }
  
  reportDataForExcel: any;
  myArray: any;
  myFilter: any;
  myArrayFiltered: any;

  title: string;
  reportName: string;
  model: any;
  today = this.calendar.getToday();

  // Stack bar


  public stackBarChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: {
      display: false,
      position: 'right',
    },
    title: {
      display: false,
      text: 'Test Suite Name',
      position: 'bottom'
    },
    scales: {
            xAxes: [{
                stacked: true
            }],
            yAxes: [{
                stacked: true
            }]
        },
        plugins: {
          labels: {
            render: 'value',
            fontColor: ['green', 'white', 'red'],
            precision: 2
          }
        },
  };

  public stackBarChartLabels: string[];
  public stackBarChartType: string = 'bar';
  // horizontalBar
  public stackBarChartLegend: boolean = true;
  stackChartData: [] = [];
  public stackBarChartColors: any[] = [
    {
      backgroundColor: '#5CB85C',
    },
    {
      backgroundColor: '#D9534F',
    },
    {
      backgroundColor: '#EC3B0F',
    },
    {
      backgroundColor: '#F0AD4E',
    },
    {
      backgroundColor: '#F0AD4E',
    },
    {
      backgroundColor: '#66CDAA',
    },
  ];

  public stackBarChartData: any[]=[
    { data: [], label: 'Pass' },
    { data: [], label: 'Fail' },
    { data: [], label: 'Blocked' },
    { data: [], label: 'Inconclusive' },
    { data: [], label: 'NotRun' },
    { data: [], label: 'Skipped' }
  ];

latestReportDisabled: any;
// historicalReport: boolean = false;

pager: any = {};

// paged items
pagedItems: any[];

pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;

  timeZoneData = new Array();
  availZone: any;
  public href: string = "";
  test1: any;
  myDate = new Date();
  projectReportDataCopy: any;
  selectedTz: string ='Asia/Calcutta';
  selectedSuite: any;
  previousUrl: any=[];
  currentUrl: string;
  previousUrltemp: any;
  navigateTab: boolean = false;
  agentCheck: boolean;
  webrunSettings=[];
  customerName: string[];
  webRunSettingName: any[];
  settingNameId: any[];
  reportId: any;
  constructor(
    private report: ReportService,
    private project: ProjectService,
    private testService: TestService,
    private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private route: ActivatedRoute,
  private toastrService:ToastrService,
  private confirmationDialogService:ConfirmationDialogService,
  private excelService:ExcelService,
  private calendar: NgbCalendar,
  private router: Router,
  private datepipe: DatePipe,
  private pagerService: PagerService,
  private memoryService: MemoryService,
  private homeService: HomeService,
  private urlService:UrlService,
  @Inject( DOCUMENT ) private document: Document,
  ) {
    this.customerName = environment.customerName;
    this.test1 = this.datepipe.transform(this.myDate, 'yyyy-MM-dd');
    this.url = environment.baseUrl;
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
   }
  
   @ViewChild('testReport') testReport: ElementRef;
   @ViewChild('moveTab') moveTab: ElementRef;
   @ViewChild('histroryTab') histroryTab: ElementRef;
   ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.title = '';
    this.loadTimeZone();
    // //console.log('timeZones',timeZones);
    
    this.initFromToDate();
   this.reportId = this.route.snapshot.queryParams['reportId'];
     this.route.paramMap.subscribe(
       params => {
         this.projectId = params.get('pid');
         this.title = params.get('value');
         this.getweRunSetting(this.projectId);
         if (this.title === 'latest' && !this.reportId) {
           this.href = this.router.url;
           this.latestReportDisabled = false;
           console.log('testUrl', this.router.url);

           //console.log(this.router.url);
           this.reportName = 'Latest Execution Report';
           this.headerOptions.heading = "Latest Execution Report";
           //set header details
           this.homeService.setHeaderOptions(this.headerOptions);
           if (this.testReport) {
             this.testReport.nativeElement.click();
           }
           let endDate = new Date(JSON.parse(JSON.stringify(this.toDate + ' 23:59:59')));
           // endDate.setHours(23);
           // endDate.setMinutes(59);
           // endDate.setSeconds(59);
           let fDate = Math.floor(new Date(this.fromDate).getTime());
           let tDate = Math.floor(new Date(endDate).getTime());
           this.report.getExecutionReport(this.projectId, fDate, tDate, this.statusV, this.suiteValue).subscribe((
             data => {
               this.projectReportData = data['testExecutionStats'];

               //console.log('latest project report', this.projectReportData);
               if (this.projectReportData !== undefined) {
                 this.projectReportDataCopy = JSON.parse(JSON.stringify(this.projectReportData))
                 this.getSuite();
                 this.getSuitReport(this.projectReportData[0].testProjectReport.id, true);
                 // setTimeout(() => {
                 //   this.moveTab.nativeElement.click();

                 // }, 0);
               } else {
                 this.isLatestReportDisable();
                 //console.log('projectReportData222',this.projectReportData);

                 this.toastrService.clear();
                 this.toastrService.warning('No Latest Execution Report !')


               }
             }
           ))
         }
        
         else if (this.title === 'historical' && !this.reportId) {
           // this.projectReportData =[];
           this.reportName = 'Historical Execution Report';
           this.headerOptions.heading = "Historical Execution Report";
           //set header details
           this.homeService.setHeaderOptions(this.headerOptions);
           if (this.histroryTab) {
             this.histroryTab.nativeElement.click();
           }
           this.isLatestReportDisable();
           let endDate = new Date(JSON.parse(JSON.stringify(this.toDate)));
           endDate.setHours(23);
           endDate.setMinutes(59);
           endDate.setSeconds(59);
           let fDate = Math.floor(new Date(this.fromDate).getTime());
           let tDate = Math.floor(new Date(endDate).getTime());
           this.report.getExecutionReport(this.projectId, fDate, tDate, this.statusV, this.suiteValue).subscribe((
             data => {
               this.projectReportData = data['testExecutionStats'];

               // this.setPage(1);
               //console.log('historical project report', this.projectReportData);
               if (this.projectReportData !== undefined) {
                 this.projectReportDataCopy = JSON.parse(JSON.stringify(this.projectReportData))
                 // this.setPage(1)
                 // this.latestReportDisabled = true;  
                 this.exportPdf = false;
                 this.getSuite();
                 // this.setPage(1)
                 // this.getSuitReport(this.projectReportData[0].testProjectReport.id,false);
               } else {
                 this.isLatestReportDisable();
                 this.toastrService.clear();
                 this.toastrService.warning('No Historical Execution Report !')

               }
             }
           ))
         }
         this.project.getProjectById(this.projectId).subscribe(
           (data) => {
             this.projectData = data;
             this.headerOptions.data = {
               projectId: this.projectId,
               projectName: data['projectName']
             };
             //set header details
             this.homeService.setHeaderOptions(this.headerOptions);
             this.projectName = this.projectData.projectName;
           }
         )
       }
     )


    //console.log('title',this.title);
    if("historical"===this.title){
      this.isLatestReportDisable();
      // this.setPage(1);
      this.exportPdf = false;
    }

    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  openSuitReportInNewTab(reportId,newTab){
    console.log('url', this.router.url);
    // this.router.navigate( ['/report/testReport/' + this.projectId +'/historical'], { queryParams: { reportId: reportId}});
    const url = this.router.serializeUrl(this.router.createUrlTree(['/report/testReport/' + this.projectId +'/latest'], {
      queryParams: {
        reportId: reportId,
        newTab: true,
      }
  }))
    window.open('#' + url, '_blank');
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
  isLatestReportDisable(){
    //console.log('latestReportDisabled',this.latestReportDisabled);
    // this.setPage(1);
    if(this.latestReportDisabled){
     
      // this.exportPdf = true;sssssss
      setTimeout(() => {
        this.histroryTab.nativeElement.click();
        this.latestReportDisabled = true;
        // this.exportPdf = false;
      }, 10);
     
    }else{
      setTimeout(() => {
        // this.histroryTab.nativeElement.click();
        this.latestReportDisabled = true;
        // this.exportPdf = false;
      }, 10);
      // this.exportPdf = false;
    }
    
  }

  

  
  loadTimeZone = function () {
    var timeZones = moment.tz.names();
    if (timeZones) {
        for (var i = 0; i < timeZones.length; i++) {
            var data = new Object();
            data['key'] = timeZones[i];
            data['value'] = timeZones[i];
            this.timeZoneData.push(data);
            this.availZone = {
              collections: {
                field: this.timeZoneData
            }
            }
            
        }
    }
};




  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject  = {};

    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
    //console.log('newArray',newArray);
    
     return newArray;
}

  ngAfterViewInit() {
    if(this.title==='latest' && !this.reportId){
   this.navigateTab = true;
   this.getSuitReport(this.projectReportData[0].testProjectReport.id,true);
    }
    else if (this.reportId) {
      this.href = this.router.url;
      this.latestReportDisabled = false;
      console.log('testUrl', this.router.url);

      //console.log(this.router.url);
      this.reportName = 'Latest Execution Report';
      this.headerOptions.heading = "Latest Execution Report";
      //set header details
      this.homeService.setHeaderOptions(this.headerOptions);
      if (this.testReport) {
        this.testReport.nativeElement.click();
      }
      let endDate = new Date(JSON.parse(JSON.stringify(this.toDate + ' 23:59:59')));
      // endDate.setHours(23);
      // endDate.setMinutes(59);
      // endDate.setSeconds(59);
      let fDate = Math.floor(new Date(this.fromDate).getTime());
      let tDate = Math.floor(new Date(endDate).getTime());
      this.report.getExecutionReport(this.projectId, fDate, tDate, this.statusV, this.suiteValue).subscribe((
        data => {
          this.projectReportData = data['testExecutionStats'];

          //console.log('latest project report', this.projectReportData);
          if (this.projectReportData !== undefined) {
            this.projectReportDataCopy = JSON.parse(JSON.stringify(this.projectReportData))
            this.getSuite();
            this.getSuitReport(this.reportId, true);
            // setTimeout(() => {
            //   this.moveTab.nativeElement.click();

            // }, 0);
          } else {
            this.isLatestReportDisable();
            //console.log('projectReportData222',this.projectReportData);

            this.toastrService.clear();
            this.toastrService.warning('No Latest Execution Report !')


          }
        }
      ))
    }
  }

initFromToDate()
{
  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2,"0");
  var date  =  String(today.getDate()).padStart(2,"0")
  this.toDate = year + "-" + month + "-" + date;
  
  const now = new Date();
  var lastWeek = new Date(now.getFullYear(), now.getMonth(), 1);
  var year1 = lastWeek.getFullYear();
  var month1 = String(lastWeek.getMonth() + 1).padStart(2,"0");
  var date1  =  String(lastWeek.getDate()).padStart(2,"0")
  this.fromDate = year1 + "-" + month1 + "-" + date1;
}

onPageChange(newValue) {
  this.selectedPage = newValue;
  this.perpageitem = newValue;
}

// setPage(page: number) {
//   // get pager object from service
//   //console.log('');
  
//   this.pager = this.pagerService.getPager(this.projectReportData.length, page);ssssssssssssssssss

//   // get current page of items
//   this.pagedItems = this.projectReportData.slice(this.pager.startIndex, this.pager.endIndex + 1);
// }




suiteChartShow(id){

  // //console.log('this.getSuitReportData suiteChartShow', this.getSuitReportData);
  // //console.log('id',id);
  // let data = this.suitFileData.filter(t => t.title === id);
  // //console.log('data',data[0].dynamicTestResult.resultState);
  // let result2 = data[0].dynamicTestResult.resultState;
  let result = this.getSuitReportData[0];
  // //console.log('result1',result);
  // //console.log('result2',result2);
  
  let chartObj = new Chart();
  chartObj.pass = result.pass;
  chartObj.fail = result.fail;
  chartObj.blocked = result.blocked;
  chartObj.inconclusive = result.inconclusive;
  chartObj.notRun = result.notRun;
  chartObj.skipped = result.skipped;
  let arrays: any[]=[];
  let dataNumbers: any[]=[];
  arrays.push(Object.values(chartObj));
  dataNumbers = JSON.parse(JSON.stringify(arrays[0]));
  const toNumbers = arr => arr.map(Number);
  var n = toNumbers(dataNumbers);
  // //console.log('toNumbers',n);
  this.barChartData = [{ data:n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
  
  
  
  // this.getSuite();
}
suitValue(value){
  this.selectedSuite = value;
  console.log("suiteData ", value)
  if(value != 'ALL')
  {
    let selectedItem = this.suit.find((element)=> element.title == value)
    
    this.suiteValue = selectedItem.id;
  }
  else
  {
    this.suiteValue = 'ALL';
  } 
}

public timeZoneChanged(timeZone: string): void {
  //console.log(timeZone, this.locatorReportDataCopy, this.locatorReportData);
  if(this.projectReportDataCopy)
  {
    this.projectReportData = JSON.parse(JSON.stringify(this.projectReportDataCopy));
    //console.log(this.locatorReportData, this.locatorReportDataCopy)
  }
  
  if(this.projectReportData)
  {
        this.projectReportData.map((element,index) => {
        
          
          // let time1 = moment(element.date, "x").tz(timeZone).unix();
          let stime = moment(element.testProjectReport.startTime, "x").tz(timeZone).format(" MMM DD YYYY hh:mm a");
          let eTime = moment(element.testProjectReport.endTime, "x").tz(timeZone).format(" MMM DD YYYY hh:mm a");
          element.testProjectReport.startTime = stime;
          element.testProjectReport.endTime = eTime;
          //element.date = time;
         });
         
  }

  ////console.log(this.locatorReportData);

  // this.tzDate = moment('Mar 24, 2022 14:46:40').tz(timeZone);
  this.selectedTz = timeZone;

 // this.updateTime(timeZone);
}
tzValue(value){
  this.tz = value;
  console.log(this.tz);
  
}

getSuite(){
  
    this.suit = [{ title : 'ALL', id : '' }];
    var suiteReport = [];
      for(let s of this.projectReportData){
        if(s.testProjectReport.testSuiteSummary){
          suiteReport.push(s.testProjectReport.testSuiteSummary[0])
        }
        
      }
     
      var suiteData = this.removeDuplicates(suiteReport,'title');
      // console.log('suiteData',suiteData);
      
      for(let d of suiteData){
        let obj = { title : d.title, id : d.testDataId};
        this.suit.push(obj);
      }
   
 
         
             //console.log('suit',this.suit);
}

statusValue(value){
this.statusV = value;
}
onFilterReport(updateReportForm){
  //console.log(updateReportForm.value)
 // let endDate =  new Date(JSON.parse(JSON.stringify(this.toDate)));
  //endDate.setHours(23);
  //endDate.setMinutes(59);
  //endDate.setSeconds(59);
 
  let endDate = this.toDate+" 23:59:59";
  let fDate = Math.floor(new Date(this.fromDate).getTime());
  let tDate = Math.floor(new Date(endDate).getTime());
  let e = new Date(this.test1).getTime();
  var fromDate = Math.floor(new Date(updateReportForm.value.fromDate).getTime());
  var toDate =   Math.floor(new Date(updateReportForm.value.toDate).getTime());
  if(toDate > e )
  {
    this.toastrService.info('Please select current or past date');
    return
  }
  if(fromDate > e )
  {
    this.toastrService.info('Please select current or past date');
    return
  }
  
  if(toDate < fromDate){
    this.toastrService.info('Please select end date after start date');
    return;
  }
 
 
  
  // let fromDate = Math.floor(new Date(updateReportForm.value.fromDate).getTime());
  // let toDate =   Math.floor(new Date(updateReportForm.value.toDate).getTime());
  //console.log('from', fromDate , 'to', toDate);
  //console.log('updateReportForm',updateReportForm.value)
  // let endDate = new Date(JSON.parse(JSON.stringify(new Date(updateReportForm.value.toDate))));
  // endDate.setHours(23);
  // endDate.setMinutes(59);
  // endDate.setSeconds(59);
  
  // this.fromDate = Math.floor(new Date(updateReportForm.value.fromDate).getTime());
  // this.toDate =   Math.floor(new Date(endDate).getTime());
  // const status1 = updateReportForm.value.
  //console.log('from',this.fromDate , 'to', this.toDate);
  // this.loadLocator(this.count);
  this.settingNameId = this.getWebRunSettingId();
  // console.log(this.settingNameId.toString());
  if(this.settingNameId && this.settingNameId.length>0){
   var settingName = this.settingNameId.toString()
  }
  else{
    settingName = null;
  }
  if(this.suiteValue == 'ALL'){
    //console.log(this.suiteValue);
    if(this.settingNameId && this.customerName){
     
      this.report.getrunSettingExecutionReport(this.projectId,fDate,tDate,this.statusV,this.suiteValue,settingName).subscribe((
      data=>{
        this.projectReportData=data['testExecutionStats'];
       
        //console.log('projectReportData',this.projectReportData);
              // this.getSuite();
        
              this.suiteValue = 'ALL';
              if (this.projectReportData !== undefined) {
               this.getSuite();
                // this.getSuitReport(this.projectReportData[0].testProjectReport.id,true);
              }else{
                // this.isLatestReportDisable();
                // //console.log(projectReportData222',this.projectReportData);
                
                if(this.title=='latest'){
                  this.toastrService.clear();
                  this.toastrService.warning('No Latest Execution Report !')
                }
                else{
                  this.toastrService.clear();
                  this.toastrService.warning('No historical Execution Report !')
                }
                
      
              }
      }
    ))
  }
  else{

    this.report.getExecutionReport(this.projectId,fDate,tDate,this.statusV,this.suiteValue).subscribe((
      data=>{
        this.projectReportData=data['testExecutionStats'];
       
        //console.log('projectReportData',this.projectReportData);
              // this.getSuite();
        
              this.suiteValue = 'ALL';
              if (this.projectReportData !== undefined) {
               this.getSuite();
                // this.getSuitReport(this.projectReportData[0].testProjectReport.id,true);
              }else{
                // this.isLatestReportDisable();
                // //console.log(projectReportData222',this.projectReportData);
                
                if(this.title=='latest'){
                  this.toastrService.clear();
                  this.toastrService.warning('No Latest Execution Report !')
                }
                else{
                  this.toastrService.clear();
                  this.toastrService.warning('No historical Execution Report !')
                }
                
      
              }
      }
    ))
  }
  }
  else if(this.suiteValue !== 'ALL'){
    //console.log('suiteValue',this.suiteValue)
    //console.log('this.suitFileData',this.suitFileData);
    
    // this.suiteId = this.suitFileData.filter((f)=>f.title==this.suiteValue);
    // this.suiteValue = this.suiteId[0].id;
  
    if(this.settingNameId.length>0){
      this.report.getrunSettingExecutionReport(this.projectId,fDate,tDate,this.statusV,this.suiteValue,this.settingNameId.toString()).subscribe((
        data=>{
          this.projectReportData=data['testExecutionStats'];
          // this.suiteValue = 'ALL';
          if (this.projectReportData !== undefined) {
           this.getSuite();
            // this.getSuitReport(this.projectReportData[0].testProjectReport.id,true);
          }else{
            // this.isLatestReportDisable();
            // //console.log('projectReportData222',this.projectReportData);
            if(this.title=='latest'){
              this.toastrService.clear();
              this.toastrService.warning('No Latest Execution Report !')
            }
            else{
              this.toastrService.clear();
              this.toastrService.warning('No historical Execution Report !')
            }
          
            
  
          }
        }
      ))     
    }
    else{
      this.report.getrunSettingExecutionReport(this.projectId,fDate,tDate,this.statusV,this.suiteValue,'null').subscribe((
        data=>{
          this.projectReportData=data['testExecutionStats'];
          // this.suiteValue = 'ALL';
          if (this.projectReportData !== undefined) {
           this.getSuite();
            // this.getSuitReport(this.projectReportData[0].testProjectReport.id,true);
          }else{
            // this.isLatestReportDisable();
            // //console.log('projectReportData222',this.projectReportData);
            if(this.title=='latest'){
              this.toastrService.clear();
              this.toastrService.warning('No Latest Execution Report !')
            }
            else{
              this.toastrService.clear();
              this.toastrService.warning('No historical Execution Report !')
            }
          
            
  
          }
        }
      ))
    }
  
  }
}

selectChartType(chartType){
  this.barChartType = chartType;
  // this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
}
pdfButtonShow(flag){
  if(flag){
    this.exportPdf = flag;
  }else{
    this.exportPdf = flag;
  }
}

getSuitReport(reportId,flag){
  this.getSuitReportData = {};
  // //console.log('this.projectReportData',this.projectReportData); 8292222333
  this.getSuitReportData = this.projectReportData.filter((f)=>f.id == reportId);
  //console.log('this.getSuitReportData',this.getSuitReportData);
  this.exportPdf = true;
  //console.log('latestReportDisabled',this.latestReportDisabled);
  
  if(flag){
    // this.moveTab.nativeElement.click();
    if(this.title==='latest'){
     this.latestReportDisabled = false;
    
        this.testReport.nativeElement.click();
      
    }else{
      if(this.latestReportDisabled){
        this.latestReportDisabled = false;
        // this.exportPdf = true;
        setTimeout(() => {
          this.testReport.nativeElement.click();
          this.latestReportDisabled = true;
          // this.exportPdf = false;
        }, 0);
       
        //console.log('latestReportDisabled',this.latestReportDisabled);
      }else{
        this.latestReportDisabled = true;
        // this.exportPdf = false;
        //console.log('latestReportDisabled',this.latestReportDisabled);
      }
    }
    
   
  }
  
  // alert(reportId);ssssssssssssssssssssssss
  this.stackBarChartData= [{ data: [], label: 'Pass' },
  { data: [], label: 'Fail' },
  { data: [], label: 'Blocked' },
  { data: [], label: 'Inconclusive' },
  { data: [], label: 'NotRun' },
  { data: [], label: 'Skipped' }]
  var clearData: any;

  
  

  
  for(let c of this.getSuitReportData){
    let chartObj = new Chart();
    chartObj.pass = c.pass;
    chartObj.fail = c.fail;
    chartObj.blocked = c.blocked;
    chartObj.inconclusive = c.inconclusive;
    chartObj.notRun = c.notRun;
    chartObj.skipped = c.skipped;
    this.chartList.push(chartObj);
  }
  
  //console.log('chartList',this.chartList);
  
  this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
  for(let c of this.chartList){
    this.blinkArry.push(Object.values(c));
  }
  this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
  const toNumbers = arr => arr.map(Number);
   var n = toNumbers(this.numarray);
  this.barChartData = [{ data:n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
  

  var stackChart = new Object();
  stackChart['pass']= this.getSuitReportData[0].pass
  stackChart['fail']= this.getSuitReportData[0].fail
  stackChart['blocked']= this.getSuitReportData[0].blocked
  stackChart['inconclusive']= this.getSuitReportData[0].inconclusive
  stackChart['notRun']= this.getSuitReportData[0].notRun
  stackChart['skipped']= this.getSuitReportData[0].skipped
  
  let map = new Map();
  map.set( this.getSuitReportData[0]['testProjectReport']['testSuiteSummary'][0].title,stackChart);
  // //console.log('map',map);
  let jsonObject = {}; 
  map.forEach((value, key) => {  
         jsonObject[key] = value  
  });  
  let jsonString: any = JSON.parse(JSON.stringify(jsonObject));
  // //console.log('json',jsonString);
  this.stackBarChartLabels = Object.keys(jsonString);
    this.stackBarChartLabels.forEach(label => {
      // //console.log('label', this.stackBarChartData[0].data.push(jsonString[label]['pass']));
      
      this.stackBarChartData[0].data.push(jsonString[label]['pass']);
      this.stackBarChartData[1].data.push(jsonString[label]['fail']);
      this.stackBarChartData[2].data.push(jsonString[label]['blocked']);
      this.stackBarChartData[3].data.push(jsonString[label]['inconclusive']);
      this.stackBarChartData[4].data.push(jsonString[label]['notRun']);
      this.stackBarChartData[5].data.push(jsonString[label]['skipped']);
    });
  // this.getSuite2(this.getSuitReportData);
  this.suiteChartShow(reportId);
  // this.moveTab.nativeElement.click();
  // this.historicalReport = false;
  // this.latestReport = true;
}

moveToSelectedTab(tabName: string) {
  for (let i =0; i< document.querySelectorAll('.mat-tab-label-content').length; i++) {
  if ((<HTMLElement>document.querySelectorAll('.mat-tab-label-content')[i]).innerText == tabName) 
     {
        (<HTMLElement>document.querySelectorAll('.mat-tab-label')[i]).click();
     }
   }
  //  this.historicalReport = false;
  //  this.latestReport = true;
}
includeTestSuit(){
  this.enableSuite = true;
}

onChecked(isChecked: boolean) {
  if(isChecked) {
    this.enableSuite = true;
  } else{
    this.enableSuite = false; 
  }
}

onChange(index:string, isChecked: boolean) {
  this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;

  if(isChecked) {
    this.indexFormArray.push(new UntypedFormControl(index));
    if(this.indexFormArray.value.length > 0){
      this.enableMergereport = true;
      // for(let i=0; i<this.indexFormArray.value.length;i++){

      // } 
    }

    //console.log(this.indexFormArray.value);
  } else {
    let Index = this.indexFormArray.controls.findIndex(x => x.value == index)
    this.indexFormArray.removeAt(Index);
    //console.log(this.indexFormArray.value)
    if(this.indexFormArray.length < 1){
      this.enableMergereport = false;
    }
  }
}
  async getFilterFromArray(){
  this.jsonToBeUsedForList = [];

  for (var index in  this.indexFormArray.value) {
    this.item = {};
    this.item['key'] = index;
    this.item['value'] =  this.indexFormArray.value[index];
    this.jsonToBeUsedForList.push(this.item);
}
//console.log(this.jsonToBeUsedForList);
  this.myArray = this.projectReportData;
  this.myFilter = this.jsonToBeUsedForList;
  
  this.myArrayFiltered = this.myArray.filter((el) => {
    return this.myFilter.some((f) => {
      return f.value === el.id ;
    });
  });
  //console.log(this.myArrayFiltered);
 
 var reportDataForCheck = await this.getDataForMerze(); 
 //console.log(reportDataForCheck);
 var excelReportData = new Array();
 var counter = 1;
 for (var k = 0; k < reportDataForCheck.length; k++) {
  for (var z = 0; z < reportDataForCheck[k].testCaseSummaryReport.length; z++) {
      var tempObject = new Object();
      tempObject['SrNo'] = counter++;
      tempObject['Test_Suite'] = reportDataForCheck[k].title;
      tempObject['TC_Id'] = reportDataForCheck[k].testCaseSummaryReport[z].testCaseId;
      tempObject['TC_Description'] = reportDataForCheck[k].testCaseSummaryReport[z].description;
      tempObject['TC_Title'] = reportDataForCheck[k].testCaseSummaryReport[z].title;
      tempObject['Status'] = reportDataForCheck[k].testCaseSummaryReport[z].resultState.status;
      tempObject['StartTime'] = reportDataForCheck[k].testCaseSummaryReport[z].startTime;
      tempObject['EndTime'] = reportDataForCheck[k].testCaseSummaryReport[z].endTime;
      tempObject['Duration'] = this.testService.getDuration(reportDataForCheck[k].testCaseSummaryReport[z].startTime, reportDataForCheck[k].testCaseSummaryReport[z].endTime);
      tempObject['FailureCategory'] = "";
      tempObject['FailureReason'] = this.testService.getFailedReason(reportDataForCheck[k].testCaseSummaryReport[z].failedReason);
      excelReportData.push(tempObject);
  }
}
this.exportAsXLSX( excelReportData);
}



async getDataForMerze(){
  const excelReportData1: any = [{
    SrNo:'',
    Test_Suite: '',
    TC_Id: '',
    TC_Description: '',
    TC_Title:'',
    Status:'',
    StartTime: '',
    EndTime: '',
    Duration: '',
    FailureCategory:'',
    FailureReason:'',
  }];
  var excelReportData = [];
  // let result  = await function()
  for(let i=0;i<this.myArrayFiltered.length;i++){

    const promise = await this.testService.getTestSuiteTestReport(this.projectId,this.myArrayFiltered[i].id,this.myArrayFiltered[i].testProjectReport.testSuiteSummary[0].testDataId,this.myArrayFiltered[i].testProjectReport.testSuiteSummary[0].path,this.myArrayFiltered[i].testProjectReport.testSuiteSummary[0].title,this.myArrayFiltered[i].testProjectReport.testSuiteSummary[0].dataIterationIndex)
    .toPromise().then((data)=>{
      if(data){
        excelReportData.push(data)
      }
     else{
       return;
     }
    })
  }
 return excelReportData;
  
}


exportPdfReport(projectId, reportType, projectReportId) {
  var uploadUrl = this.url + '/HuLoopRest/huloop/testReport/pdfReport/' + projectId + '/' + reportType + '/' + projectReportId;
  this.toastrService.clear();
  this.toastrService.success('Exporting file...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>', null, {
      extendedTimeOut: 0,
      timeOut: 0,
      enableHtml: true
  });
  this.http.post(uploadUrl, null, {
      headers: {
          "accept": "application/octet-stream"
      },
      responseType: 'arraybuffer'
  }).subscribe(
     (response: any) => {
      let fileName = this.projectName + '.PDF';
     
      var data = new Blob([response], {
        type: 'application/octet-stream'
    });
      saveAs(data, fileName);
      this.toastrService.clear();
        this.toastrService.success("Report exported successfully");
    },
    
  );
}


									

exportAsXLSX(excelReport):void {
  this.excelService.exportAsExcelFile(excelReport, 'report-summary');
}
dropdownSettings: any = {};
showFilter = false;
getweRunSetting(projectId){
  this.report.getrunSetting(projectId).subscribe(
    (runSettings)=>{
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 5,
        allowSearchFilter: this.showFilter
      };
      console.log('runSettings',runSettings);
      this.webrunSettings = runSettings['webRunSetting']
      this.webRunSettingName = [];
      this.webrunSettings.forEach(element => {
        this.webRunSettingName.push(element.settingName)
      });
      console.log('runSettings',this.webRunSettingName);
    }
  )
}
selectedRunSetting = []
onItemSelect(item: any) {
  // this.selectedKeys=[];
  //console.log('onItemSelect', item);
  this.selectedRunSetting.push(item);
  console.log(this.selectedRunSetting);

}
onItemDeSelect(item: any) {
  var index = this.selectedRunSetting.indexOf(item);
  if (index !== -1) {
    this.selectedRunSetting.splice(index, 1);
  }
  //console.log(item);
  console.log(this.selectedRunSetting);

}
getWebRunSettingId(){
  let webRunsettingId = [];
  if(this.webrunSettings){
    this.webrunSettings.forEach(element => {
      this.selectedRunSetting.forEach(
       (element1)=>{
         if(element1 == element.settingName){
           webRunsettingId.push(element.id)
         }
       }
      )
   });
 return webRunsettingId;
  }
  else{
    return null
  }
}
// downloadReport(){
//   // if ($scope.suiteReportdata.length === 0) {
//   //     toastr.clear();
//   //     toastr.warning("Kindly select at least one suite to download report");
//   //     return;
//   // }

//   this.toastrService.clear();
//   this.toastrService.success('Report is downloading ...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>', null, {
//       extendedTimeOut: 0,
//       timeOut: 0,
//       enableHtml: true
//   });
//   var tempExcelArray = new Array();
//   var promise = new Array();
//   for (var j = 0; j < this.myArrayFiltered.length; j++) {
//       var tempData = this.myArrayFiltered[j];
//       var queryData = tempData.split(":");
//       var tempProjectId = queryData[0];
//       var tempReportId = queryData[1];
//       var temptestSuiteId = queryData[2];
//       var tempPathId = queryData[3];
//       var tempTitle = queryData[4];
//       var tempdataItertaion = queryData[5];
//       promise.push(testCaseReportService.getTestProjectReport(tempProjectId, tempReportId, encodeURI(temptestSuiteId), encodeURI(tempPathId), encodeURI(tempTitle), tempdataItertaion));
//   }

//   all(promise).then(
//           function (data) {
//               var apiResponseArray = data;
//               var excepReportData = new Array();
//               var counter = 1;
          //     for (var k = 0; k < apiResponseArray.length; k++) {
          //         for (var z = 0; z < apiResponseArray[k].testCaseSummaryReport.length; z++) {
          //             var tempObject = new Object();
          //             tempObject['SrNo'] = counter++;
          //             tempObject['Test_Suite'] = apiResponseArray[k].title;
          //             tempObject['TC_Id'] = apiResponseArray[k].testCaseSummaryReport[z].testCaseId;
          //             tempObject['TC_Description'] = apiResponseArray[k].testCaseSummaryReport[z].description;
          //             tempObject['TC_Title'] = apiResponseArray[k].testCaseSummaryReport[z].title;
          //             tempObject['Status'] = apiResponseArray[k].testCaseSummaryReport[z].resultState.status;
          //             tempObject['StartTime'] = apiResponseArray[k].testCaseSummaryReport[z].startTime;
          //             tempObject['EndTime'] = apiResponseArray[k].testCaseSummaryReport[z].endTime;
          //             tempObject['Duration'] = $scope.getDuration(apiResponseArray[k].testCaseSummaryReport[z].startTime, apiResponseArray[k].testCaseSummaryReport[z].endTime);
          //             tempObject['FailureCategory'] = "";
          //             tempObject['FailureReason'] = $scope.getFailedReason(apiResponseArray[k].testCaseSummaryReport[z].failedReason);
          //             excepReportData.push(tempObject);
          //         }
          //     }
            
          // });



// };
}




